// extracted by mini-css-extract-plugin
export default {"videoItem":"video_videoItem__K1+dL"};